import React from 'react';
import contact from './contact.module.css';
import { useForm } from 'react-hook-form';
import { TextField } from '@mui/material';
import { contact as contactApi } from '../../../Services/APIrequests'; 
import { SuccessSwal, warningSwal } from '../../../Util/Toast'; 

const ContactForm = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset, 
    } = useForm();

    const onSubmit = async (data) => {
        try {
            const requestData = {
                fullName: data.fullName,
                email: data.emailaddress,
                subject: data.subject,
                message: data.message,
            };

            // Call the API
            const response = await contactApi(requestData);

            // Show success message (Assuming the API response has a message)
            SuccessSwal('Your message has been sent successfully!', response.data.message);

            // Reset the form fields after successful submission
            reset();
        } catch (error) {
            console.error('Error submitting contact form:', error);
            warningSwal('Something went wrong, please try again later.');
        }
    };

    return (
        <div className={contact.formcontact}>
            <div className={contact.login_form}>
                <h3>We are always ready to solve your problems</h3>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className={contact.form1}>
                        <div className={contact["form-control"]}>
                            <TextField
                                id="outlined-basic"
                                label="Full Name"
                                variant="outlined"
                                type="text"
                                {...register('fullName', {
                                    required: 'Full Name is required!',
                                })}
                            />
                            {errors?.fullName && (
                                <p className={contact.error}>
                                    {errors?.fullName?.message}
                                </p>
                            )}
                        </div>
                        <div className={contact["form-control"]}>
                            <TextField
                                id="outlined-basic"
                                label="Email"
                                variant="outlined"
                                type="email"
                                {...register('emailaddress', {
                                    required: 'Email Address is required!',
                                    pattern: {
                                        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                        message: 'Invalid email address',
                                    },
                                })}
                            />
                            {errors?.emailaddress && (
                                <p className={contact.error}>
                                    {errors?.emailaddress?.message}
                                </p>
                            )}
                        </div>
                    </div>
                    <div className={contact["form-control"]}>
                        <TextField
                            id="outlined-basic"
                            label="Subject"
                            variant="outlined"
                            type="text"
                            {...register('subject', {
                                required: 'Subject is required!',
                            })}
                        />
                        {errors?.subject && (
                            <p className={contact.error}>
                                {errors?.subject?.message}
                            </p>
                        )}
                    </div>
                    <div className={contact["form-control"]}>
                        <TextField
                            id="outlined-basic"
                            label="Message"
                            variant="outlined"
                            type="text"
                            {...register('message', {
                                required: 'Message is required!',
                            })}
                        />
                        {errors?.message && (
                            <p className={contact.error}>
                                {errors?.message?.message}
                            </p>
                        )}
                    </div>
                    <input type="submit" value="Send Message" />
                </form>
            </div>
        </div>
    );
};

export default ContactForm;
